module.exports = __webpack_public_path__ + "img/logo.7f35d6ff.png";